@if (!httpError) {
  <div id="content-advance-simulator">
    <app-advance-simulator-form
      #formSimulatorAdvanced
      (emitForm)="onEmitForm($event)"
      (returnHttpError)="onReturnHttpError($event)"
      (onSaveForm)="saveForm($event)"
    ></app-advance-simulator-form>

    <div class="col-12 no-pd form-btn-group d-flex justify-content-end">
      <!-- <button id="advance-simulator-save-form" *ngIf="status < listStatus?.simulation_done" class="btn btn-01" (click)="saveAdvanceData()">{{ 'advance_sumulator_btn_save' | translate }}</button> -->
      <button id="advance-simulator-calculate-mortgage" class="btn btn-02" (click)="saveAndSimulate()">
        {{ 'advance_sumulator_btn_calculate_mortgage' | translate }}
      </button>
    </div>
  </div>
} @else {
  <app-error-detail></app-error-detail>
}
